import actions from '../../actionTypes';

export default trigger => {
  return {
    type: actions.ADD_TRIGGER,
    trigger
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/addTrigger.js